/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from "react-router-dom";
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';
import { ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ListItemSelector from "../common/ListItemSelector";
import Checkbox from "../common/Checkbox";
import SelectInput from "../common/SelectInput";
import Input from "../common/Input";
import { ROLES } from "../common/Const";
import {
  getNormalizedSchoolYearStartYearFromSearch,
  pushManageRouteWithSchoolYear,
} from "./manageSchoolYearRouting";

const getParticipationStatusText = (student) => {
  if (student.participationStatus === "cancelledOnTime") {
    return "Odwolano w terminie";
  }

  if (student.participationStatus === "cancelledLate") {
    return "Odwolano po terminie";
  }

  return "";
};

const getCancellationNoticeText = (student) => {
  const noticeHours = student.cancellation && student.cancellation.cancellationNoticeHours;
  return noticeHours === undefined || noticeHours === null
    ? ""
    : `Wyprzedzenie: ${noticeHours} h`;
};

const getDefaultReportedAtValue = () => {
  const now = new Date();
  const offsetMs = now.getTimezoneOffset() * 60000;
  return new Date(now.getTime() - offsetMs).toISOString().slice(0, 16);
};

const LessonModal = ({
  index,
  lesson,
  display,
  lessonDetailsEx,
  studentsEx,
  studentsNotInThisClassEx,
  teachers,
  students,
  onDateChange,
  weekdays,
  getDayOfWeek,
  getNameById,
  onAddStudent,
  onUndoChanges,
  onDetailsChange,
  onAttendanceChange,
  onSubmit,
  onDelete,
  showModal,
  showLessonDetailsMenu,
  showAddStudentMenu,
  setShowModal,
  setShowLessonDetailsMenu,
  setShowAddStudentMenu,
  showRemoveMode,
  setShowRemoveMode,
  onRemoveStudent,
  role,
  userTeacherId,
  canSubmit,
  canUseAdministrativeLessonCommands,
  canUndoWholeLessonCancellation,
  isWholeLessonCancelled,
  onReportAbsence,
  onCancelWholeLesson,
  onUndoWholeLessonCancellation,
}) => {
  const canManageLessonDetails = role !== ROLES.TEACHER;
  const canEditAttendance = (role !== ROLES.TEACHER || lessonDetailsEx.teacherId === userTeacherId) && !isWholeLessonCancelled;
  const [absenceFormOpen, setAbsenceFormOpen] = useState(false);
  const [lessonCancellationFormOpen, setLessonCancellationFormOpen] = useState(false);
  const [absenceDraft, setAbsenceDraft] = useState({
    studentId: "",
    reportedAt: getDefaultReportedAtValue(),
    note: "",
  });
  const [lessonCancellationReason, setLessonCancellationReason] = useState("");
  const [commandError, setCommandError] = useState("");
  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowLessonDetailsMenu(false);
    setShowAddStudentMenu(false);
    setAbsenceFormOpen(false);
    setLessonCancellationFormOpen(false);
    setCommandError("");
  };

  const history = useHistory();
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);


  return (
    <>
      {display === "table" ? (
        <div className={`table-row row m-0 d-flex manage-text text-center cursor-pointer ${index % 2 !== 0 ? "table-row-alternate" : ""} ${lesson.lessonRegister ? "visible-border-left" : "transparent-border-left"}`}>
          <div className="col-10 col-sm-11">
            <div className="row d-flex align-items-center" onClick={handleShowModal}>
              <div className="col-sm-3 table-cell">{lessonDetailsEx.date}</div>
              <div className="col-sm-3 table-cell">{getDayOfWeek(lessonDetailsEx.dayOfWeek)}</div>
              <div className="col-sm-3 table-cell">{lessonDetailsEx.startTime}</div>
              <div className="col-sm-3 table-cell">{getNameById(teachers, lessonDetailsEx.teacherId)}</div>
            </div>
          </div>
          <div className="col-2 col-sm-1 p-0 d-flex align-items-center justify-content-center table-cell">
            {lessonDetailsEx.comment && (
              <OverlayTrigger overlay={<Tooltip>{lessonDetailsEx.comment}</Tooltip>}>
                <i className="fas fa-flag fa-lg" />
              </OverlayTrigger>
            )}
          </div>
        </div>
      ) : (
        <div className={`display-block w-100 cursor-pointer ${lesson.lessonRegister ? "dark-background" : "light-background"}`} onClick={handleShowModal}>
          {studentsEx.length === 0 ? (
            <div className="student-name-display-block empty-lesson-display-block">&nbsp;</div>
          ) : (
            studentsEx.map(student => (
              <div key={student.id} className="student-name-display-block">{getNameById(students, student.id)}</div>
            ))
          )}
        </div>
      )}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Body>
          
          <Button
            onClick={() => {
              setShowLessonDetailsMenu(!showLessonDetailsMenu);
              setShowAddStudentMenu(false);
            }}
            aria-expanded={showLessonDetailsMenu}
            className="col-12 mb-3"
            variant="outline-dark"
          >
              Zmień dane TYCH zajęć
          </Button>
          

          {canManageLessonDetails && lesson.defaultLessonDetails.isRecurring && (
            <Button
              onClick={() => {
                setShowLessonDetailsMenu(!showLessonDetailsMenu);
                setShowAddStudentMenu(false);
                setShowRemoveMode(false);
                const id = lesson.id;
                const cleanId = id.includes("-") ? id.substring(0, id.lastIndexOf("-")) : id;
                pushManageRouteWithSchoolYear(
                  history,
                  `/manage/class/${cleanId}`,
                  location.search,
                  activeSchoolYearStartYear,
                  { from: '/manage/' },
                );
              }}
              className="col-12 mb-3"
              variant="outline-primary"
            >
              Zmień dane WSZYSTKICH zajęć
            </Button>
          )}
          <Collapse in={showLessonDetailsMenu}>
            <div id="">
              <form id="group-form">
                {canManageLessonDetails && (
                  <div className="form-row">
                    <div className="col-sm-7 col-6">
                      <SelectInput
                        label="Dzień tygodnia"
                        name="dayOfWeek"
                        value={lessonDetailsEx.dayOfWeek}
                        defaultOption="Wybierz dzień tygodnia"
                        options={weekdays.map(d => ({
                          value: d.id,
                          text: d.name,
                        }))}
                        readOnly
                        onChange={() => {}}
                      />
                    </div>
                    <div className="col-sm-5 col-6">
                      <Input type="date" label="Data" onBlur={() => { }} onChange={e => onDateChange(e)} name="date" value={lessonDetailsEx.date} />
                    </div>
                  </div>
                )}
                {canManageLessonDetails && (
                  <div className="form-row">
                    <div className="col-sm-3 col-4">
                      <Input label="Godzina" onBlur={() => { }} type="time" onChange={onDetailsChange} name="startTime" value={lessonDetailsEx.startTime} placeholder="Początek zajęć" />
                    </div>
                    <div className="col-sm-9 col-8">
                      <SelectInput
                        label="Nauczyciel"
                        onBlur={() => { }}
                        onChange={onDetailsChange}
                        name="teacherId"
                        value={lessonDetailsEx.teacherId}
                        defaultOption="Wybierz nauczyciela"
                        options={teachers.map(t => ({
                          value: t.id,
                          text: `${t.firstName} ${t.lastName}`,
                        }))}
                      />
                    </div>
                  </div>
                )}
                <div className="form-row">
                  <div className="col-12">
                    <Input
                      label="Uwagi"
                      type="textarea"
                      onBlur={() => { }}
                      onChange={onDetailsChange}
                      name="comment"
                      value={lessonDetailsEx.comment}
                      placeholder="Uwagi"
                      readOnly={!canSubmit}
                    />
                  </div>
                </div>
              </form>
            </div>
          </Collapse>
          {isWholeLessonCancelled && (
            <div className="alert alert-secondary">
              <div className="font-weight-bold">Lekcja odwolana</div>
              <div>{lessonDetailsEx.lessonCancellation && lessonDetailsEx.lessonCancellation.reason}</div>
              {canUndoWholeLessonCancellation && (
                <Button
                  variant="outline-secondary"
                  className="mt-2"
                  onClick={() => {
                    setCommandError("");
                    onUndoWholeLessonCancellation()
                      .catch(error => setCommandError(error.message || "Nie udalo sie cofnac odwolania lekcji."));
                  }}
                >
                  Cofnij odwolanie lekcji
                </Button>
              )}
            </div>
          )}
          {commandError && <div role="alert" className="alert alert-danger">{commandError}</div>}
          {canUseAdministrativeLessonCommands && (
          <>
            <Button
              onClick={() => {
                setShowAddStudentMenu(!showAddStudentMenu);
                setShowRemoveMode(false);
                setShowLessonDetailsMenu(false);
              }}
              aria-controls="student-list"
              aria-expanded={showAddStudentMenu}
              className="col-6 mb-3"
              variant="outline-success"
            >
              Dodaj ucznia
            </Button>
            <Button
              onClick={() => {
                setShowRemoveMode(prev => !prev);
                setShowAddStudentMenu(false);
                setShowLessonDetailsMenu(false);
              }}
              className="col-6 mb-3"
              variant="outline-danger"
            >
              {showRemoveMode ? "Wyłącz usuwanie" : "Usuń ucznia"}
            </Button>

          </>
          )}
          
          {canUseAdministrativeLessonCommands && (
            <>
              <Button
                onClick={() => {
                  setAbsenceFormOpen(!absenceFormOpen);
                  setShowAddStudentMenu(false);
                  setShowRemoveMode(false);
                  setShowLessonDetailsMenu(false);
                  setLessonCancellationFormOpen(false);
                }}
                className="col-6 mb-3"
                variant="outline-warning"
              >
                Zgloszenie nieobecnosci
              </Button>
              <Button
                onClick={() => {
                  setLessonCancellationFormOpen(!lessonCancellationFormOpen);
                  setShowAddStudentMenu(false);
                  setShowRemoveMode(false);
                  setShowLessonDetailsMenu(false);
                  setAbsenceFormOpen(false);
                }}
                className="col-6 mb-3"
                variant="outline-danger"
              >
                Odwolaj lekcje
              </Button>
            </>
          )}

          <Collapse in={showAddStudentMenu}>
            <div id="student-list">
              <ListItemSelector label="" onSelect={onAddStudent} options={studentsNotInThisClassEx} />
            </div>
          </Collapse>
          <Collapse in={absenceFormOpen}>
            <div className="border p-3 mb-3">
              <SelectInput
                label="Uczen"
                name="studentId"
                value={absenceDraft.studentId}
                defaultOption="Wybierz ucznia"
                options={studentsEx.map(student => ({
                  value: student.id,
                  text: getNameById(students, student.id),
                }))}
                onChange={event => setAbsenceDraft({ ...absenceDraft, studentId: event.target.value })}
                onBlur={() => {}}
              />
              <Input
                label="Kiedy otrzymalismy zgloszenie"
                type="datetime-local"
                name="reportedAt"
                value={absenceDraft.reportedAt}
                onChange={event => setAbsenceDraft({ ...absenceDraft, reportedAt: event.target.value })}
                onBlur={() => {}}
              />
              <Input
                label="Notatka"
                type="textarea"
                name="note"
                value={absenceDraft.note}
                placeholder="Opcjonalna notatka"
                onChange={event => setAbsenceDraft({ ...absenceDraft, note: event.target.value })}
                onBlur={() => {}}
              />
              <Button
                variant="warning"
                onClick={() => {
                  if (!absenceDraft.studentId) {
                    setCommandError("Wybierz ucznia.");
                    return;
                  }
                  setCommandError("");
                  onReportAbsence({
                    studentId: absenceDraft.studentId,
                    reportedAt: new Date(absenceDraft.reportedAt).toISOString(),
                    note: absenceDraft.note,
                  })
                    .then(() => setAbsenceFormOpen(false))
                    .catch(error => setCommandError(error.message || "Nie udalo sie zapisac zgloszenia nieobecnosci."));
                }}
              >
                Zapisz zgloszenie
              </Button>
            </div>
          </Collapse>
          <Collapse in={lessonCancellationFormOpen}>
            <div className="border p-3 mb-3">
              <Input
                label="Powod odwolania lekcji"
                type="textarea"
                name="lessonCancellationReason"
                value={lessonCancellationReason}
                placeholder="Podaj powod odwolania lekcji"
                onChange={event => setLessonCancellationReason(event.target.value)}
                onBlur={() => {}}
              />
              <Button
                variant="danger"
                onClick={() => {
                  if (!lessonCancellationReason.trim()) {
                    setCommandError("Podaj powod odwolania lekcji.");
                    return;
                  }
                  setCommandError("");
                  onCancelWholeLesson({ reason: lessonCancellationReason })
                    .then(() => setLessonCancellationFormOpen(false))
                    .catch(error => setCommandError(error.message || "Nie udalo sie odwolac lekcji."));
                }}
              >
                Potwierdz odwolanie lekcji
              </Button>
            </div>
          </Collapse>
          <div className="modal-title">Lista obecności</div>
          <ListGroup className="row d-flex" variant="horizontal">
            {studentsEx.map(student => (
              <ListGroup.Item key={student.id} className="border-0 pb-0 col-sm-6 position-relative">
                <div>
                  <Checkbox
                    name="isPresent"
                    label={getNameById(students, student.id)}
                    onChange={e => onAttendanceChange({ ...e, studentId: student.id })}
                    isChecked={student.isPresent}
                    readOnly={!canEditAttendance}
                    onBlur={() => {}}
                  />
                  {getParticipationStatusText(student) && (
                    <div className="small text-muted ml-4">
                      <span>{getParticipationStatusText(student)}</span>
                      {getCancellationNoticeText(student) && (
                        <span>{` (${getCancellationNoticeText(student)})`}</span>
                      )}
                    </div>
                  )}
                  {canUseAdministrativeLessonCommands && showRemoveMode && (
                  <Button
                    variant="link"
                    className="text-danger p-0"
                    onClick={() => onRemoveStudent(student)}
                    style={{ position: 'absolute', fontSize: '1.7rem', top: '0.5rem', right: '0.5rem' }}
                  >
                    <i className="fas fa-times fa-lg" />
                  </Button>
                  )}
                </div>
              </ListGroup.Item>

            ))}
          </ListGroup>


        </Modal.Body>
        <Modal.Footer>
          {canManageLessonDetails && (
            <button type="button" className="btn manage-button btn-success mr-2" onClick={onUndoChanges}><i className="fas fa-undo" /></button>
          )}
          {canManageLessonDetails && !isWholeLessonCancelled && (
            <button type="button" className="btn manage-button btn-dark mr-auto ml-0" onClick={onDelete}><i className="fas fa-trash-alt fa-lg" /></button>
          )}
          <div className="row d-flex">
            <button type="button" className="btn manage-button manage-teal-button mr-2" onClick={handleCloseModal}>Powrót</button>
            <button
              type="button"
              className="btn manage-button manage-red-button mr-2"
              onClick={onSubmit}
              disabled={!canSubmit || isWholeLessonCancelled}
            >
              Zapisz
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

LessonModal.propTypes = {
  lesson: PropTypes.object.isRequired,
  display: PropTypes.string.isRequired,
  lessonDetailsEx: PropTypes.object.isRequired,
  studentsEx: PropTypes.array.isRequired,
  studentsNotInThisClassEx: PropTypes.array.isRequired,
  teachers: PropTypes.array.isRequired,
  students: PropTypes.array.isRequired,
  onDateChange: PropTypes.func.isRequired,
  weekdays: PropTypes.array.isRequired,
  getDayOfWeek: PropTypes.func.isRequired,
  getNameById: PropTypes.func.isRequired,
  onAddStudent: PropTypes.func.isRequired,
  onUndoChanges: PropTypes.func.isRequired,
  onDetailsChange: PropTypes.func.isRequired,
  onAttendanceChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  showLessonDetailsMenu: PropTypes.bool.isRequired,
  showAddStudentMenu: PropTypes.bool.isRequired,
  showRemoveMode: PropTypes.bool.isRequired,
  setShowRemoveMode: PropTypes.func.isRequired,
  onRemoveStudent: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  setShowLessonDetailsMenu: PropTypes.func.isRequired,
  setShowAddStudentMenu: PropTypes.func.isRequired,
  role: PropTypes.string,
  userTeacherId: PropTypes.string,
  canSubmit: PropTypes.bool,
  canUseAdministrativeLessonCommands: PropTypes.bool,
  canUndoWholeLessonCancellation: PropTypes.bool,
  isWholeLessonCancelled: PropTypes.bool,
  onReportAbsence: PropTypes.func,
  onCancelWholeLesson: PropTypes.func,
  onUndoWholeLessonCancellation: PropTypes.func,
};

LessonModal.defaultProps = {
  role: "",
  userTeacherId: "",
  canSubmit: true,
  canUseAdministrativeLessonCommands: false,
  canUndoWholeLessonCancellation: false,
  isWholeLessonCancelled: false,
  onReportAbsence: () => Promise.resolve(),
  onCancelWholeLesson: () => Promise.resolve(),
  onUndoWholeLessonCancellation: () => Promise.resolve(),
};

export default LessonModal;
